"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandingPageChannel = exports.DiscountType = exports.LandingPageLinkState = exports.LandingPageState = void 0;
var LandingPageState;
(function (LandingPageState) {
    LandingPageState["ACTIVE"] = "ACTIVE";
    LandingPageState["ARCHIVED"] = "ARCHIVED";
    LandingPageState["PENDING"] = "PENDING";
    LandingPageState["DELETED"] = "DELETED";
    LandingPageState["FAILED"] = "FAILED";
})(LandingPageState || (exports.LandingPageState = LandingPageState = {}));
var LandingPageLinkState;
(function (LandingPageLinkState) {
    LandingPageLinkState["ACTIVE"] = "ACTIVE";
    LandingPageLinkState["ARCHIVED"] = "ARCHIVED";
    LandingPageLinkState["PENDING"] = "PENDING";
    LandingPageLinkState["DELETED"] = "DELETED";
    LandingPageLinkState["GENERATION_FAILED"] = "GENERATION_FAILED";
})(LandingPageLinkState || (exports.LandingPageLinkState = LandingPageLinkState = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENT"] = "PERCENT";
    DiscountType["FIXED"] = "FIXED";
    DiscountType["OTHER"] = "OTHER";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
var LandingPageChannel;
(function (LandingPageChannel) {
    LandingPageChannel["PAID"] = "PAID";
    LandingPageChannel["OWNED"] = "OWNED";
})(LandingPageChannel || (exports.LandingPageChannel = LandingPageChannel = {}));
